import { render, staticRenderFns } from "./AgentBotTriggers.vue?vue&type=template&id=f4b48588&"
import script from "./AgentBotTriggers.vue?vue&type=script&lang=js&"
export * from "./AgentBotTriggers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports